/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus>): BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus(), model);
        BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus>): BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus.newInstance(<BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
